import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { store } from 'redux-rest-reducer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { get as getApplicantDetail } from 'actions/applicant-detail';

import ApplicantProfile from './applicant-profile';

const TeacherApplicantForm = ({ actions, teacherApplicantDetail }) => {
  const [applicantDetail, setapplicantDetail] = useState({});

  const { applicantId: applicantId } = useParams();

  useEffect(() => {
    actions.getApplicantDetail(applicantId);
  }, [applicantId]);

  useEffect(() => {
    const applicantDetailGet = store.get(teacherApplicantDetail, applicantId);
    if (applicantDetailGet && applicantDetailGet.isLoaded) {
      setapplicantDetail(applicantDetailGet.data);
    }
  }, [teacherApplicantDetail]);

  return (
    <div>
      <ApplicantProfile applicantDetail={applicantDetail} />
    </div>
  );
};

export default connect(
  ({ teacherApplicantDetail }) => ({
    teacherApplicantDetail,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getApplicantDetail,
      },
      dispatch,
    ),
  }),
)(TeacherApplicantForm);
